<div class="page-breadcrumb" *ngIf="read==true || delete==true ">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">User Management</h4>
        </div>

    </div>
</div>


<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <diV class="row">
                                <div class="col-sm-12 col-md-10">
                                    <label>All Users</label>
                                </div>
                               
                                <div class="col-md-1">
                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="filter()">
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter</button>
                                    </div>

                                </div>
                                <div class="col-md-1" *ngIf="export==true">

                                    <div id="zero_config_filter" class="dataTables_filter" (click)="exportTable()">
                                        <button style="background-color: #e0e09e">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>

                                </div>
                            </diV>
                            <div *ngIf="showFilter" style="background-color: #e0e09e;margin-top: 15px;width:895px">
                                <div class="container-fluid" style="color: black">
                                   
                                    <input style="margin-top: 29px;" type="radio" id="mobile" name="gender" [(ngModel)]="filterValueSelected" 
                                    value="mn"  (change)="applyCustomizedFilter()"> Mobile Number &nbsp;&nbsp;
                                    

                                </div>
                                <div style="margin-left: 820px">
                                    <button class="btn btn-dark" (click)="filter()">Cancel</button>

                                </div>
                            </div>
                            <div>
                                <div>
                                    <mat-form-field *ngIf="showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput  [(ngModel)]="searchValue"
                                            (keyup)="applyCustomizedFilterSearch(searchValue)">

                                    </mat-form-field>
                                    <mat-form-field *ngIf="!showCustomisedSearch">
                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                        <ng-container matColumnDef="_id">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> User Id</th>
                                            <td *matCellDef="let row" style="padding-left: 14px;">
                                                {{row._id}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="mobileNumber">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
                                            <td *matCellDef="let row">
                                                {{row.mobileNumber}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="mobileStatus">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number Status
                                            </th>
                                            <td *matCellDef="let row">
                                                {{row.mobileStatus}}
                                            </td>
                                        </ng-container>
                                       
                                       
                                       
                                        <ng-container matColumnDef="firstName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
                                            <td *matCellDef="let row">
                                                {{row.firstName}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="lastName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
                                            <td *matCellDef="let row">
                                                {{row.lastName}}
                                            </td>
                                        </ng-container>
                                       <!--  <ng-container matColumnDef="DOB">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>DOB</th>
                                            <td *matCellDef="let row">
                                                <div *ngIf="row.status==false"
                                                    style="background-color: #e8e1e1;height:50px;width:103%">
                                                    {{row.DOB|date}}</div>
                                                <div *ngIf="row.status==true">
                                                    {{row.DOB|date}}</div>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="gender">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Gender</th>
                                            <td *matCellDef="let row">
                                                <div *ngIf="row.status==false"
                                                    style="background-color: #e8e1e1;height:50px;width:103%">
                                                    {{row.gender}}</div>
                                                <div *ngIf="row.status==true">
                                                    {{row.gender}}</div>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="location">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
                                            <td *matCellDef="let row">
                                                <div *ngIf="row.status==false"
                                                    style="background-color: #e8e1e1;height:50px;width:103%">
                                                    {{row.location}}</div>
                                                <div *ngIf="row.status==true">
                                                    {{row.location}}</div>
                                            </td>
                                        </ng-container> -->
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>User Status
                                            </th>
                                            <td *matCellDef="let row">
                                                <span *ngIf="row.status==true"> Active</span>
                                                <span *ngIf="row.status==false"> In Active</span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="dateOfCreation">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Of Registration
                                            </th>
                                            <td *matCellDef="let row">
                                                {{row.dateOfCreation|date}}
                                            </td>
                                        </ng-container>
                                      
                                        <ng-container matColumnDef="Action">
                                            <th mat-header-cell *matHeaderCellDef>Actions</th>

                                            <td *matCellDef="let row">
                                                <p *ngIf="read==true  && delete!=true && write !=true "
                                                    style="color:#353556;font-family: initial;font-weight: 500;">You
                                                    didn't have permission for actions</p>

                                                <ul class="list-group list-group-flush"
                                                    *ngIf="write==true || delete==true">
                                                    <li class="list-group-item  friend-list mb-2">
                                                     
                                                        <div class="dropdown show float-right list-block">
                                                            <a class="userDropdown" href="#" role="button"
                                                                style="margin-right: 186px;" id="userDropdown"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false"></a>
                                                            <div class="dropdown-menu dropdown-menu-right"
                                                                aria-labelledby="userDropdown">

                                                                <button class="dropdown-item" *ngIf="delete==true"
                                                                    (click)="deleteuser(row._id)">
                                                                    <i class="fa fa-trash p-2"
                                                                        aria-hidden="true"></i>Delete</button>
                                                                <div *ngIf="write==true">
                                                                    <mat-slide-toggle
                                                                        (change)="onChange($event,row._id)"
                                                                        [checked]="row.status">
                                                                        <span *ngIf="row.status==false">
                                                                            In Active</span>
                                                                        <span *ngIf="row.status==true">
                                                                            Active</span>
                                                                    </mat-slide-toggle>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25,100]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<!-- End Container fluid  -->